import React from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

const StyledButton = (props) => <ButtonStyle {...props}>{props.children}</ButtonStyle>;

const ButtonStyle = styled(Button)``;

export default StyledButton;
